import {useEffect, useCallback, useState, useRef} from 'react';

const useContextMenu = () => {
	const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
	const [show, setShow] = useState(false);
	const [position, setPosition] = useState({x: 'right', y: 'bottom'});
	const [height, setHeight] = useState(0)
	const menuRef = useRef()

	const handleContextMenu = useCallback(
		(event) => {
			event.preventDefault();

			let x,
				y;

			const pageX = event.pageX;
			const position = pageX + 190;

			if (position > window.innerWidth) {
				x = 'left'
			} else {
				x = 'right'
			}

			const pageY = event.pageY;
			const bottomPosition = pageY + height + height;

			if (bottomPosition > window.innerHeight) {
				y = 'top'
			} else {
				y = 'bottom'
			}

			setPosition({
				x, y
			})

			setAnchorPoint({ x: event.offsetX + 14, y: event.offsetY + 10 });
			setShow(true);
		},
		[setShow, setAnchorPoint]
	);

	const handleClick = useCallback(() => (show ? setShow(false) : null), [show]);

	useEffect(() => {
		menuRef.current.addEventListener("click", handleClick);
		menuRef.current.addEventListener("contextmenu", handleContextMenu);
		return () => {
			if (menuRef.current !== null) {
				menuRef.current.removeEventListener("click", handleClick);
				menuRef.current.removeEventListener("contextmenu", handleContextMenu);
			}
		};
	});
	return { menuRef, anchorPoint, show, setShow, position, setHeight };
};

export default useContextMenu;